import React from 'react'
import Nav from './Nav/Nav'
import HeaderContent from './HeaderContent/HeaderContent'

export default function Header() {
  return (
    <>
        <HeaderContent />
    </>
  )
}
